import { render, staticRenderFns } from "./ServicesStats.vue?vue&type=template&id=a183019c&"
import script from "./ServicesStats.vue?vue&type=script&lang=js&"
export * from "./ServicesStats.vue?vue&type=script&lang=js&"
import style0 from "./ServicesStats.vue?vue&type=style&index=0&id=a183019c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports